/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "I0KSaqiv5C0",
    title:
      "Liquid Paper | If Bruce Lee shuffled cards... | Cardistry by Virtuoso",
    creator: "thevirts",
    category: "Hall of Fame",
    description: `While Cardistry was first birthed centuries ago from magicians who desired to add some flourishes to their card handling, it in itself contains no magic at all. In fact, while card magic involves the concealment of movement, Cardistry is the very opposite - revolving around the expression and aesthetics of movement and form. In other words, borders often end up obscuring what the Cardist wishes to showcase.
    
    Unfortunately, Cardistry was always regarded as a niche within the niche of magic, and Cardists had to make do with whatever decks they could get in their hands - that is, until Virtuoso came along.`,
    createdAt: new Date(2016, 4, 20) // 20 May 2016
  },
  {
    _id: "S7kG641iA_g",
    title:
      "RISE | Crazy card moves with no CGI, strings, or magnets | Cardistry by Virtuoso",
    creator: "thevirts",
    category: "Trending",
    description: `A note from The Virts about "RISE":
    
    If there's one thing we've learned from shuffling cards over the past 14 years, it's that you only get better at Cardistry as you repeatedly push yourself beyond your limits. The byproduct of that, of course, is dropping cards - again, and again, and again.
    
    Today, after 14 years... we still drop our cards all the time. Sure, we now drop our cards less frequently; but no matter how much better we've gotten, bending to the floor and repeatedly picking cards up covered in dust (and hair) never gets any less frustrating.`,
    createdAt: new Date(2017, 11, 8) // 8 Dec 2017
  },
  {
    _id: "V4Z74-9y9Ys",
    title: "TURBO / Cardistry by Noel Heath / Anyone 2018",
    creator: "anyone worldwide",
    category: "Hall of Fame",
    description: `Credits: Jonas Haglund, Nikolaj Honoré, Tobias Levin, Zach Mueller, Mario Lopez, James Chesmore, Patrick Varnavas, Franco Pascali, Aviv, Oliver Sogard, Dimitri Arleri
    
    Noel's instagram: @noelheath
    
    anyoneworldwide.com
    @anyoneww`,
    createdAt: new Date(2018, 0, 25) // 25 Jan 2018
  },
  {
    _id: "Etyn-vUg-bI",
    title: "Tutorial: PRISM by Andrew Avila | Cardistry Touch",
    creator: "Cardistry Touch",
    category: "Tutorials",
    description: `PRISM is a modern classic by Andrew Avila. This unique card structure is definitely one of the best moves of the last 10 years.
    
    Cardistry performed by Andrew Avila
    Photography direction by Francois Dubois
    Editing by François Dubois`,
    createdAt: new Date(2018, 2, 27) // 27 Mar 2018
  },
  {
    _id: "wNL7Vsw2L2A",
    title: "Tutorial: RIFFLE FAN by Dimitri Arleri | Cardistry Touch",
    creator: "Cardistry Touch",
    category: "Tutorials",
    description: `The Riffle Fan was first showcased in Dimitri's video “Silent Transition” in 2011. It has then been published in his dvd “Monument” (https://store.theory11.com/products/m...), but because the mechanics of the move evolved with the years, we've decide to release an upgraded tutorial.
    
    The Riffle Fan is definitely one of Dimitri's most treasured and favorite creation, and it's considered as modern classic: there is no doubt that adding it to your repertoire will help you grow as a cardist.
    
    Enjoy!

    Cardistry performed by Dimitri Arleri
    Photography direction by Francois Dubois
    Editing by Ladislas Toubart`,
    createdAt: new Date(2017, 3, 14) // 14 Apr 2017
  },
  {
    _id: "GeGs2a0MUds",
    title: "BLACK BELT | Cardistry | Zach Mueller | 2015",
    creator: "Fontaine Cards",
    category: "Hall of Fame",
    description: `Credit to Daniel Lin, Adam Kerchman, Noel Heath, Dimitri Arleri, Christian Engblom, Franco Pascali, Franky Morales, Chase Duncan and Andrei Jikh.`,
    createdAt: new Date(2015, 3, 15) // 15 Apr 2015
  },
  {
    _id: "yQ7oeZwCrlI",
    title: "Cardistry-Con Championship 2016 - Final: Nguyen Hoang Duy",
    creator: "Nguyen Hoang Duy",
    category: "Cardistry-Con",
    description: `instagram @nguyen.hoang.duy
                   @di.cardistry
gmail:FDflourisher@gmail.com
www.dicardistry.com
`,
    createdAt: new Date(2016, 6, 11) // 11 Jul 2016
  },
  {
    _id: "-iH9xOEpGfE",
    title: "Cardistry-Con Championship 2019 - Final: Salvador González",
    creator: "Salvador González",
    category: "Cardistry-Con",
    description: ``,
    createdAt: new Date(2019, 6, 30) // 30 Jul 2019
  },
  {
    _id: "l_z1DK-vABE",
    title: "SEQUENCE",
    creator: "Av1vM",
    category: "Hall of Fame",
    description: `this video is a part of a cardistry project that can be seen here
http://shop.dananddave.com/project-av....
enjoy =)

Music: Thriftworks - Observations 

Credits:
Spencer Clark
Dan And Dave Buck
Dimitri Arleri
Devo
Jerry
Brendan Conner
Alejandro Portela (Thecuso)
Luka
Daren Yeow
Oliver Sogard`,
    createdAt: new Date(2012, 9, 7) // 7 Oct 2012
  },
  {
    _id: "BS459HTciy4",
    title:
      "WELCOME by Ladislas & Dimitri | Performance Video | Cardistry Touch",
    creator: "Cardistry Touch",
    category: "Hall of Fame",
    description: `This is our first performance video as a company, and we're glad to share with you our latest cardistry creations!

Cardistry performed by Ladislas Toubart & Dimitri Arleri
Photography direction by Francois Dubois
Editing by Ladislas Toubart
Music by 20syl "Back & Forth"`,
    createdAt: new Date(2016, 6, 14) // 14 Jul 2016
  },
  {
    _id: "lc-MhmuGEX0",
    title: "MATERIA // Cardistry by Yang Nguyen",
    creator: "Yang Cardistry",
    category: "Trending",
    description: `Hope you enjoy this short video I made for Cardistry Touch!

Playing Cards: Materia by Cardistry Touch
Performed by Yang Nguyen`,
    createdAt: new Date(2021, 8, 23) // 23 Sept 2021
  },
  {
    _id: "2241tL_ErFQ",
    title: "UNCUT CHALLENGE // Uncut Cardistry by Yang Nguyen",
    creator: "Yang Cardistry",
    category: "Trending",
    description: `Playing Cards: Arctic Echo by Lotus in Hand
Performed by Yang Nguyen
Music: Solis Occasum by Gyvus`,
    createdAt: new Date(2021, 9, 11) // 11 Oct 2021
  },
  {
    _id: "xDI5F7fo2z4",
    title: "CAUGHT IN THE ACT / CARDISTRY BY NIKOLAJ HONORÉ",
    creator: "anyone worldwide",
    category: "",
    description: `MOVE LIST:
SPIN DOCTOR
LANCELOT
LOWRIDER
FILLER
DRIVE TRHOUGH
DARLING
SOME KINDA WERM
2020
DR. JONES
NISEKO
THREEFOLD

INSPIRATION/CREDITS:
TOBIAS LEVIN
OLIVER SOGARD
BRENDAN CONNER
NOEL HEATH
EDGAR ISAAC 
DAN BUCK
DAVE BUCK
AVIV MORALY
JUSTIN KELLY
TASH ALAM
ALEJANDRO PORTELA

ANYONE 2019 ©
6006 WORLDWIDE
https://anyoneworldwide.com`,
    createdAt: new Date(2019, 5, 3) // 3 Jun 2019
  },
  {
    _id: "qqdP2aTwnqw",
    title: `Round 4 "AKA THE FINALS" - Fontaine Trials 2021`,
    creator: "Fontaine Cards",
    category: "Trending",
    description: `@trin.chngk
@skykards
@nikitalus

Thank you for playing`,
    createdAt: new Date(2021, 7, 29) // 29 Aug 2021
  },
  {
    _id: "7aEFwSGHDsk",
    title: "BLACK HOLO FONTAINES // Cardistry by Fontaine Cards // 2022",
    creator: "Fontaine Cards",
    category: "Trending",
    description: `24 hour pre-order window starts now at http://www.fontainecards.com

Orders window closes tomorrow at 12:00pm PST. Orders will ship in 8-10 weeks.

edit by carter`,
    createdAt: new Date(2022, 2, 27) //27 Mar 2022
  },
  {
    _id: "yRnqekhgedk",
    title: `"THE FONTAINE FILES" TRAILER // Cardistry by Franco, Carter, James, Lewis, Kyle // 2020`,
    creator: "Fontaine Cards",
    category: "",
    description: `(0:28) Slushie
(0:36) Gaucho
(0:49) Drill bit
(0:59) Braceface
(1:18) Easy-Bake Oven
(1:30) Scribblenauts
(1:39) Double Weave Jacquard
(1:46) Offnod
(1:56) Eames
(2:07) Primo`,
    createdAt: new Date(2022, 10, 5) // 5 Nov 2020
  },
  {
    _id: "ZotLsyViGvY",
    title: `"SMALL HOURS" CARDISTRY in PARIS`,
    creator: "anyone worldwide",
    category: "Trending",
    description: `Midnight Playing Cards available online 01.31.22 - 10:00 PST
https://anyoneworldwide.com

Follow us on instagram:
https://www.instagram.com/anyone/

Soundtrack Playlist:
https://open.spotify.com/playlist/7eE...

ANYONE WORLDWIDE
UNUSUAL ENTERTAINMENT
© 2022
https://anyoneworldwide.com`,
    createdAt: new Date(2022, 0, 21) // 21 Jan 2022
  },
  {
    _id: "GdAFwEKanAA",
    title: "THE TRIUMPH - CARDISTRY BY DAVIDE RASO",
    creator: "anyone worldwide",
    category: "",
    description: `ROCKSTAR PLAYING CARDS
AVAILABLE THIS FRIDAY
09/10/21
19:00 CEST
https://anyoneworldwide.com

Davide Raso Instagram:
https://www.instagram.com/davideraso_`,
    createdAt: new Date(2021, 8, 4) // 4 Sept 2021
  },
  {
    _id: "yxHrdohD_so",
    title: "MIX 08 - CARDISTRY BY TOBIAS LEVIN",
    creator: "anyone worldwide",
    category: "",
    description: `MIX 08 -- ANYONE 2018

MOVE LIST:

00:17 SLOANE
00:23 RACKETEER
00:29 PANDA RING
00:36 PESTO
00:42 CHOP SLICE
00:49 FREEZING STAR CUT
00:55 HOTHEAD
01:14 FEATURE FIT
01:23 HOTHEAD TWO
01:33 BULLDOZE
01:41 ONE THROUGH 7

anyoneworldwide.com`,
    createdAt: new Date(2018, 5, 30) // 30 Jun 2018
  },
  {
    _id: "gJhH7jic0UQ",
    title: "PURE: Old-School Cardistry by Kevin Ho (2008)",
    creator: "Kevin Ho",
    category: "",
    description: `Backstory:
---
When I moved to California for college, I found myself using most of my free time to tinker with a deck of cards and come up with moves of my own. By the second semester, I had a decent handful of new material, plus a new HV20 camcorder that I got using the money I'd made from my book Smooth Operations. So one night, I grabbed my camera, a tripod, and a pack of Aladdins, and went down to the college gym to shoot a bunch of flourishes I'd been working on. I'd only shared this video with a small group of close friends before, but here it is now for your enjoyment.

P.S. This video is probably the first time that Backdrop ever appeared on recorded media - crazy to think that the move is 12 years old already!

---
Original video description:
---
What happens when you strip a flourish video down to its bare essentials - one man, one deck of cards, one camera angle? In the absence of video aesthetics emerges a form of beauty on its own - something PURE.`,

    createdAt: new Date(2020, 1, 26) // 26 Feb 2020
  },
  {
    _id: "BLt0hf2XpiI",
    title:
      "Cardistry Tutorial - Sick and Twisted Wings of the Mockingbird (SATWOTM) by Kevin Ho",
    creator: "Kevin Ho",
    categpry: "Tutorials",
    description: `PREREQUISITES:
One Handed Revolution 2 Tutorial:
https://www.bilibili.com/video/BV15t4...

Around the World Tutorial:
https://www.youtube.com/watch?v=NY1Hb...`,
    createdAt: new Date(2021, 1, 6) // 6 Feb 2021
  },
  {
    _id: "-sQFQEIuiTA",
    title: "Cardistry Tutorial - Snake Charmer by Kevin Ho",
    creator: "Kevin Ho",
    category: "Tutorials",
    description: `The cards used in the video are the ArrowDynamix v2s from my brand, Momentum. You can get them here if you dig 'em:
http://www.momentum.cards

PREREQUISITES:
One Handed Revolution Tutorial:
https://www.youtube.com/watch?v=OulHu...

One Handed Revolution 2 Tutorial:
https://www.bilibili.com/video/BV15t4...

Z-Grip Tutorial:
https://youtu.be/e8PAMLgLcfY?t=74`,
    createdAt: new Date(2020, 11, 24) // 24 Dec 2020
  },
  {
    _id: "JFL56Qeo-78",
    title: "ArrowDynamix Cardistry Deck - Official Trailer",
    creator: "Kevin Ho",
    category: "",
    description: `ArrowDynamix is a pet project that I first came up with in 2015. The idea of taking arrows and putting them on cards so that this ubiquitous symbol could both enhance and inform movements in Cardistry opened up a whole new world of possibilities, and over time the concept has evolved and culminated in the cards you see being used in this video.

Whether you're stacking them to create specific patterns and displays, using the arrows to act as creative hints in coming up with new moves, or if you're simply freestyling with the deck and allowing the arrows to generate random instances of apparent chaos, this deck is a tool that belongs in any Cardist's arsenal.

This trailer was filmed with the help of my friend Kyle Tran, who worked together with two Cardistry world champions - Lars Mayrand and Trevor Aguiar - along with ultra-talented Cardists Matthew Beaudouin and Azlan Valentine to capture all the lovely moves featured in this video. Do give them a follow on social media if you'd like to see more of their work!`,
    createdAt: new Date(2020, 7, 14) // 14 Aug 2020
  },
  {
    _id: "uTkZOrdsl8U",
    title: `"ANYWAY" - ArrowDynamix v3 Cardistry Deck Trailer ft. Kevin Ho`,
    creator: "Kevin Ho",
    category: "Trending",
    description: `Hey gang! This is my first solo performance video in 5 years. It's a mix of original material, classics, and some lesser-known gems by other Cardists. ANYWAY, If you liked the cards in this video, you can get them on the Momentum web store now:
https://momentum.cards/`,
    createdAt: new Date(2021, 1, 4) // 4 Feb 2021
  },
  {
    _id: "hpPm1lOSCPg",
    title: "VIRUS // Cardistry Tutorial by Noel Heath",
    creator: "Fontaine Cards",
    category: "Tutorials",
    description: ``,
    createdAt: new Date(2015, 0, 17) // 17 Jan 2015
  },
  {
    _id: "DP0uGdiwPxg",
    title: "Learn the ANACONDA DRIBBLE - Tutorial",
    creator: "Chris Ramsay",
    category: "Tutorials",
    description: `Today I'm going to teach you how to perform the Anaconda dribble. Special thanks to Bone Ho for allowing me to teach this.`,
    createdAt: new Date(2018, 6, 10) // 10 Jul 2018
  },
  {
    _id: "zdfWIgDe9Gw",
    title: "Cardistry | POWER PLAY by Daniel Lin",
    creator: "lotusinhand",
    category: "Trending",
    description: `Moves created and performed by Daniel Lin
Filmed by Kurtis Lin
Edited by Daniel Lin & Kurtis Lin
Written by Kurtis Lin & Daniel Lin
Music by Ryoji Ikeda

Move List:
0:12 - Ghandi's Flip Flop
0:19 - Two Hand Ghandi's Flip Flop
0:28 - Warp
0:41 - Gravity
0:48 - Miltank
0:53 - Mosaic
1:05 - Mudslide
1:13 - Mudslide 2
1:22 - Double Instant Erection
1:33 - To and Fro
1:38 - Hide and Seek
1:43 - Newton's Cradle
1:53 - Aethera 2
2:00 - Parallax 2
2:16 - Daedalus
2:24 - Lever
2:39 - Parasite 3
2:49 - Reversybil
3:02 - Swerve`,
    createdAt: new Date(2020, 4, 9) // 9 May 2020
  },
  {
    _id: "nzZuh2PhbXw",
    title: "SELFISH | Cardistry by PATRICK VARNAVAS | 2020",
    creator: "Best Cardist Alive",
    category: "Hall of Fame",
    description: `- MOVE LIST -
SAINT ELSEWHERE
HOUND DOG
MORALS
HEY HEY
SCARAB
SEEING DOUBLE
DOCTOR STRANGE
GRIP TWIRL
QUAKE
METRONOME
PAYOLA
MAGNA CARTA
V FOR VARNAVAS
VOD
PAT ON THE BACK
OUT OF HAND
SEEING TRIPLE`,
    createdAt: new Date(2020, 0, 11) // 11 Jan 2020
  },
  {
    _id: "_BcGZbFNM0g",
    title: "WATERBEND - Cardistry Tutorial",
    creator: "Best Cardist Alive",
    category: "Tutorials",
    description: `WATERBEND is a brand new insane cascade flourish by Joe Feldpausch that curves cards as they fall through your fingers.  
Go show Joe some love for teaching such an awesome move for free!`,
    createdAt: new Date(2017, 10, 3) // 3 Nov 2017
  },
  {
    _id: "0l7SuEq0Ldo",
    title: "From the mothership",
    category: "Hall of Fame",
    creator: "Эдуард Риттер",
    description: `Чудо`,
    createdAt: new Date(2017, 11, 1) // 1 Dec 2012
  },
  {
    _id: "bdMEZtSneF8",
    title: "GOTHENBURG SHUFFLE | Cardistry | Noel Heath | 2016",
    creator: "Fontaine Cards",
    category: "Hall of Fame",
    description: `Filmed by Bizau Cristian, edited by Noel Heath. 

Credit:
zach mueller, jonas haglund, birger karlsson, aviv moraly, dimitri arleri, nikolaj, huron low`,
    createdAt: new Date(2016, 3, 25) // 25 Apr 2016
  },
  {
    _id: "Zi-2FzZ1rd8",
    title: "The Fontaine Fam | Cardistry | 2015",
    creator: "Fontaine Cards",
    category: "Hall of Fame",
    description: `Featured Cardists:
(The Fontaine Fam)
Franky Morales - @frankymeows
Noel Heath - @NoelHeath
Chase Duncan - @readysetcards
Zach Mueller - @zachmonky

Follow @fontainecards for anything and errything Fontaine.

More info on The Fontaine Fam Europe Tour will be announced in the coming weeks.`,
    createdAt: new Date(2015, 6, 23) // 23 Jul 2015
  },
  {
    _id: "NObQp8r4Wzg",
    title: `"FLOATING CARDS" | Cardistry | Zach Mueller`,
    category: "Hall of Fame",
    creator: "StatusSilver",
    description: `Performance by Zach Mueller`,
    createdAt: new Date(2015, 7, 31) // 31 Aug 2015
  },
  {
    _id: "Zwhkz9QfY14",
    title: "ANYONE - CARDISTRY - TOKYO - LAST MINUTE",
    creator: "anyone worldwide",
    category: "Hall of Fame",
    description: `Anyone who tries to win on time, will see it's only the last minute that counts.`,
    createdAt: new Date(2017, 10, 23) // 23 Nov 2017
  },
  {
    _id: "BH9DRqOGLAg",
    title: "JETPACKETS │ Cardistry",
    creator: "dealersgrip",
    category: "Hall of Fame",
    description: `
'JETPACKETS'
Cardistry created and performed by Oliver Sogard.
Video shot and edited by Tobias Levin.
Produced by dealersgrip.
Shot on location in Copenhagen, Denmark.
Music by X&G - "4am".

Credits / Inspiration:
Nikolaj Honoré
Kevin Ho
Patrick Varnavas
Tobias Levin
Dimitri Arleri
Dom Corrado
Zach Mueller
Chris Hestnes`,
    createdAt: new Date(2016, 10, 19) // 19 Nov 2016
  },
  {
    _id: "5MiqDxD_SJg",
    title: "Cardistry Tutorial — RETRIGGER by Oliver Sogard",
    creator: "dealersgrip",
    category: "Tutorials",
    description: `Retrigger is a one-handed continuous cut with universal capabilities. Learn the original Retrigger along with the infamous four-packet variation in our latest in-depth verbal tutorial.

Overview:
Performance
Introduction
Step one - Opener
Step two - Get-ready
Step three - Split
Step four - Replacement
Step five - Closer
Variation - Four-packet version [Re-Retrigger]
Uncut performances
Conclusion

RETRIGGER
Created and explained by Oliver Sogard
Inspired by Nikolaj Pedersen's "Trigger" [First published in 'New York Notes', 2015]

Additional camerawork by Henrik Forberg

Music by Woolcoin - "Konane"`,
    createdAt: new Date(2018, 3, 23) // 23 Apr 2018
  },
  {
    _id: "JuuBas8A0-A",
    title: "Cardistry-Con Championship 2016 - Round 2: Birger Karlsson (Uncut)",
    creator: "Birger Karlsson",
    category: "Cardistry-Con",
    description: `Credits: 
Dennis Jin
Thomas Maten
Nikolaj Pedersen
Henrik Forberg
Dan & Dave Buck
Dimitri Arleri
Nick Stumphauzer 
Alejandro Portela
Jonas Haglund
Liam Levanon

Camera:
Frank Sung (instagram: @frankistea)

Music:
BLVC SVND - Lament`,
    createdAt: new Date(2016, 4, 13) // 13 May 2016
  }
];
